import { ErrorResponse } from '@/schemas/errorResponseSchema';

export class ApiError extends Error {
  constructor(
    message: string,
    public readonly status: number,
    public readonly errorData?: ErrorResponse
  ) {
    super(message);
    this.name = 'ApiError';
  }
}
